import { Box, Grid } from "@mui/system";
import { Autocomplete, IconButton, TextField, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";

import GapsBetweenPlayersPerformanceTable from "./GapsBetweenPlayersPerformanceTable";

const tableHeadings = {
  brand_name: "Brand Name",
  brand_id: "Brand ID",
  brand_action_date: "Brand Action Date",
  gap_player_reporting: "Gap in Player’s Reporting",
  ftd_player_report: "FTD’s in Player Report",
  ftd_daily_report: "FTD’s in Daily Report",
};
export const rows = [
  {
    brand_name: "BetVictor Sport UK",
    brand_id: "2319",
    brand_action_date: "21/04/2026",
    gap_player_reporting: "3",
    ftd_player_report: "8",
    ftd_daily_report: "6",
  },
  {
    brand_name: "BBetVictor Sport UK",
    brand_id: "2319",
    brand_action_date: "21/04/2026",
    gap_player_reporting: "5",
    ftd_player_report: "6",
    ftd_daily_report: "8",
  },
];

const GapsBetweenPlayersPerformance = () => {
  const brandName = [
    { label: "Brand 01" },
    { label: "Brand 02" },
    { label: "Brand 03" },
    { label: "Brand 04" },
  ];

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        px={2}
        py={1.5}
        sx={{ borderTop: "1px solid #0000001F" }}
      >
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Gaps Between Players And Daily Performance
          </Typography>
        </Grid>
        <Grid size={4}>
          <Box display={"flex"} alignItems={"end"} justifyContent={"flex-end"}>
            <Autocomplete
              id="assetOrSiteName"
              disablePortal
              options={brandName}
              getOptionLabel={(option) => option.label}
              size="small"
              sx={{ pt: "8px", width: "275px" }}
              renderInput={(params) => (
                <TextField
                  color="secondary"
                  {...params}
                  required
                  placeholder="Search Brand Name or choose from the list"
                  label="Brand Name"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <SearchIcon
                          sx={{ fontSize: 20, mr: 1, color: "text.secondary" }}
                        />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <IconButton
              aria-label="fingerprint"
              color="secondary"
              sx={{ ml: 2 }}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <GapsBetweenPlayersPerformanceTable
        tableHeadings={tableHeadings}
        rows={rows}
      />
    </>
  );
};

export default GapsBetweenPlayersPerformance;
